import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { PaymentsSessionCompaniesRepository } from '@app/domain/ports/payments-companies/payments-session-companies.repository';
import { PaymentsSessionCompany } from '@app/domain/models/payments-companies/payments-route-company';
import { GestorServicesResponseDto } from '@app/data/dtos/tpv/gestor.dto';
import { mapPaymentsSessionCompanies } from '@app/data/mappers/payments/payments-session-company.mapper';

/**
 * Maqueta del caso real (sandbox 2): gestor PAYMENTS cuyo `entity_payments` es 1 y
 * cuyo comercio tiene `org_company_id` 101 ⇒ el valor de ruta es 101, nunca 1.
 * Pasa por el MISMO mapper que el remoto.
 */
export const MOCK_GESTOR_SERVICES_PAYMENTS: GestorServicesResponseDto = {
  polipay_account: '9999004130',
  include_inactive: false,
  count: 1,
  services: [
    {
      id_gestor: 1,
      id_consumed_product: 1,
      is_active: true,
      role: { id: 1, name: 'Administrador' },
      entity_type: 'Empresa',
      provider: 'Polipay Payments',
      service: 'PAYMENTS',
      payments_company: { id_company: 101, org_company_id: 101, external_ref: null, name: 'Comercio Demo' },
    },
  ],
};

@Injectable()
export class PaymentsSessionCompaniesMockDataSource extends PaymentsSessionCompaniesRepository {
  override getOwnPaymentsCompanies(_polipayAccount: string): Observable<PaymentsSessionCompany[]> {
    return of(mapPaymentsSessionCompanies(MOCK_GESTOR_SERVICES_PAYMENTS)).pipe(delay(200));
  }
}
